import { requests } from '@/libs/axios/axios'
import { NotificationEndPoints } from '../notification-endpoints'
import { AxiosResponse } from 'axios'
const getAuditReportsAgainstRandomString = async (): Promise<AxiosResponse> => {
  return requests.get(`${NotificationEndPoints.GET_REAL_NOTIFICATION}`)
}
export default getAuditReportsAgainstRandomString
